import type { LoginResponse, LoginVenueInfo } from '@pokerroom/types';

export type DeviceBindingLoginError = {
  errorCode?: string;
  requestRef?: string;
  expiresAt?: string;
};

export function requiresVenueSelection(
  data: LoginResponse,
): data is LoginResponse & { venues: LoginVenueInfo[]; venueSelectToken: string } {
  return Boolean(data.requiresVenueSelection && data.venues?.length && data.venueSelectToken);
}

export function formatDeviceBindingLoginError(response: DeviceBindingLoginError | undefined) {
  if (response?.errorCode === 'DEVICE_BINDING_PENDING') {
    return `Device approval pending${response.requestRef ? `: ${response.requestRef}` : ''}${response.expiresAt ? ` (expires ${new Date(response.expiresAt).toLocaleString()})` : ''}`;
  }
  if (
    response?.errorCode === 'DEVICE_BINDING_DENIED' ||
    response?.errorCode === 'DEVICE_BINDING_REVOKED'
  ) {
    return 'This device is not approved for the selected venue. Please sign in again or contact an administrator.';
  }
  return undefined;
}
